/* eslint-disable */
import React, { Fragment } from 'react'
import Logo from '../../components/Logo'

export default (props) => (
	<div className="row">
		<div className="header">
			<Logo />
			<h1>Hey {props.firstName},</h1>
			<p className="blurb">We’ve generated a list of creative partners, based on your needs, that can help you.</p>
			<span className="separation">. . .</span>
		</div>
	</div>
	// <header>
	// 	<h1>Hey {props.firstName},</h1>
	// 	<h2>I've created the following list of creative partners based on your requirements.</h2>
	// </header>
)


// WEBPACK FOOTER //
// ./src/containers/Results/Header.js